function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.64 8.66l4.91.54a.5.5 0 01.45.5v.6a.5.5 0 01-.45.5l-4.91.54a1 1 0 00-.61.29l-.38.4a1 1 0 00-.28.61l-.58 6.9a.5.5 0 01-.5.46h-.58a.5.5 0 01-.5-.46l-.58-6.9a1 1 0 00-.28-.61l-.38-.4a1 1 0 00-.61-.29L.45 10.8a.5.5 0 01-.45-.5v-.6a.5.5 0 01.45-.5l4.91-.54a1 1 0 00.61-.29l.38-.4a1 1 0 00.28-.61l.58-6.9a.5.5 0 01.5-.46h.58a.5.5 0 01.5.46l.58 6.9a1 1 0 00.28.61l.38.4a1 1 0 00.61.29zm1.63-2.29l-.64-.64a.5.5 0 010-.74l1.56-1.29a.51.51 0 01.68 0l.41.41a.51.51 0 010 .68L13 6.34a.5.5 0 01-.73.03zM3 13.66l-1.3 1.53a.51.51 0 000 .68l.41.41a.51.51 0 00.68 0L4.34 15a.5.5 0 000-.74l-.64-.64a.5.5 0 00-.7.04zm10.19 2.63L11.66 15a.5.5 0 01-.04-.7l.64-.64a.5.5 0 01.74 0l1.28 1.54a.51.51 0 010 .68l-.41.41a.51.51 0 01-.68 0zM4.34 5L2.81 3.7a.51.51 0 00-.68 0l-.41.41a.51.51 0 000 .68L3 6.34a.5.5 0 00.74 0l.64-.64a.5.5 0 00-.04-.7z"
});

var SvgFlare = function SvgFlare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    fill: "#27AE60"
  }, props), _ref);
};

export default SvgFlare;